import { Component } from "@angular/core";

import { RegisterPage } from "../form-section.class";

@Component({
    selector: "cfi-thank-you",
    templateUrl: "./thank-you.component.html"
})
export class ThankYouComponent extends RegisterPage { }
